import React, { Component } from "react";
import bgimg from "../../Images/5.jpg";
import { Card } from "../Card/card";
import Footer from "../Footer/footer";

export default class Proposals extends Component {
  startProposal = (type) => {
    this.props.updateFormProposalType(type);
  };

  render() {
    return (
      <React.Fragment>
        <div id="main">
          <img
            style={{
              height: "calc(100vh - 50px)",
              minWidth: "1000px",
              width: "100%",
              minHeight: "500px",
              filter: "brightness(80%)",
              position: "fixed",
              pointerEvents: "none",
            }}
            src={bgimg}
            alt="5.jpg"
          />
          <div className="">
            <div
              style={{
                position: "absolute",
                textAlign: "left",
                color: "white",
                left: "50%",
                transform: "translate(-50%)",
                height: "85vh",
              }}
            >
              <div style={{ marginTop: "25vh", height: "60vh" }}>
                <h1
                  style={{
                    fontFamily: "TrajanSansPro",
                    fontSize: "calc(12px + 2.5vw)",
                  }}
                >
                  <br /> Welcome to the
                  <br /> Vicus Capital
                  <br />
                  Proposal Generator
                  <br />
                </h1>
                <h3
                  style={{
                    fontSize: "calc(8px + 1vw)",
                    color: "rgba(255,255,255,.8)",
                    marginTop: "80px",
                  }}
                >
                  To get started, select the desired strategy below or click the
                  "Get Started" button from the menu above.
                </h3>
              </div>
              <div style={{ padding: "15px 0" }}>
                {(this.props.proposalTypesLoading ||
                  this.props.proposalTypes.length <= 0) && (
                  <div style={{ textAlign: "center" }}>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <div
                      style={{
                        marginTop: "10px",
                        color: "rgba(255,255,255,.8)",
                      }}
                    >
                      Loading proposal types...
                    </div>
                  </div>
                )}
                <div className="row" id="test">
                  {this.props.proposalTypes
                    .filter((pro) => pro.card !== "false")
                    .map((item, index) => (
                      <div
                        key={index}
                        style={{ margin: "0 auto 15px", minWidth: "auto" }}
                      >
                        <Card
                          key={item.name}
                          imgSource={item.image}
                          imgAlt={item.name}
                          title={
                            // item.name.includes("- ETP")
                            //   ? item.name.replace("- ETP", "")
                            //   : item.name.includes("- ProSelect™ ETP")
                            //   ? item.name.replace("- ProSelect™ ETP", "")
                            //   : item.name
                            item.name.includes("-")
                              ? item.name.trim().split("-")[0].trim()
                              : item.name
                          }
                          startText={
                            // item.name.includes("- ETP")
                            //   ? `${item.name.split("-")[1].trim()}`
                            //   : item.name.includes("- ProSelect™ ETP")
                            //   ? `${item.name.split("-")[1].trim()}`
                            //   : "Start"
                            item.name.includes("-")
                              ? item.name.trim().split("-")[1].trim()
                              : item.card.split(";").length > 1
                                ? "Standard"
                                : "Start"
                          }
                          prefix={item.prefix}
                          title2={item.card !== "true" ? item.card : null}
                          startText2={
                            item.card !== "true" ? `${item.card}` : null
                          }
                          text={item.slogan}
                          startColor="#385EA4"
                          startColor2="#385EA4"
                          startLink={this.startProposal}
                          startLink2={this.startProposal}
                          bgColor="rgba(162, 170, 182, 0.8)"
                          colorText="white"
                          disabled={this.props.userDataLoading}
                        />
                      </div>
                    ))}
                </div>
              </div>
              {this.props.proposalTypes.length > 0 && (
                <div>
                  <Footer />
                </div>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
